var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "harness" },
    [
      _c("div", { staticClass: "harness-bar" }, [
        _c("strong", [_vm._v("Package Offer — local styling fixture")]),
        _c("label", [
          _vm._v("Brand kit "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.kit,
                  expression: "kit"
                }
              ],
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.kit = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            [
              _c("option", { attrs: { value: "studio" } }, [
                _vm._v("Studio fixture")
              ]),
              _c("option", { attrs: { value: "minimal" } }, [
                _vm._v("Minimal fixture")
              ]),
              _c("option", { attrs: { value: "none" } }, [_vm._v("No kit")])
            ]
          )
        ]),
        _c("label", [
          _vm._v("Appearance "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.appearance,
                  expression: "appearance"
                }
              ],
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.appearance = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            [
              _c("option", { attrs: { value: "legacy" } }, [_vm._v("Legacy")]),
              _c("option", { attrs: { value: "light" } }, [_vm._v("Light")]),
              _c("option", { attrs: { value: "dark" } }, [_vm._v("Dark")]),
              _c("option", { attrs: { value: "both" } }, [_vm._v("Both")])
            ]
          )
        ]),
        _c("label", [
          _vm._v("Layout "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.item.definition.presentation.layout,
                  expression: "item.definition.presentation.layout"
                }
              ],
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.item.definition.presentation,
                    "layout",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                }
              }
            },
            [
              _c("option", [_vm._v("CARDS")]),
              _c("option", [_vm._v("STACKED")]),
              _c("option", [_vm._v("COMPARISON")])
            ]
          )
        ]),
        _c("label", [
          _vm._v("Selection "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.item.definition.selectionRules.mode,
                  expression: "item.definition.selectionRules.mode"
                }
              ],
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.item.definition.selectionRules,
                    "mode",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                }
              }
            },
            [
              _c("option", { attrs: { value: "FIXED" } }, [
                _vm._v("Everything included")
              ]),
              _c("option", { attrs: { value: "CHOOSE_ONE" } }, [
                _vm._v("Choose one")
              ]),
              _c("option", { attrs: { value: "CHOOSE_MANY" } }, [
                _vm._v("Choose multiple")
              ])
            ]
          )
        ]),
        _c("label", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.nonDecisionSigner,
                expression: "nonDecisionSigner"
              }
            ],
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.nonDecisionSigner)
                ? _vm._i(_vm.nonDecisionSigner, null) > -1
                : _vm.nonDecisionSigner
            },
            on: {
              change: function($event) {
                var $$a = _vm.nonDecisionSigner,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.nonDecisionSigner = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.nonDecisionSigner = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.nonDecisionSigner = $$c
                }
              }
            }
          }),
          _vm._v(" Non-decision signer")
        ]),
        _c("label", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.locked,
                expression: "locked"
              }
            ],
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.locked)
                ? _vm._i(_vm.locked, null) > -1
                : _vm.locked
            },
            on: {
              change: function($event) {
                var $$a = _vm.locked,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.locked = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.locked = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.locked = $$c
                }
              }
            }
          }),
          _vm._v(" Locked selection")
        ]),
        _c("p", [
          _vm._v(
            "Mock quote for layout only. Amounts do not recalculate. No API, signing or payments."
          )
        ])
      ]),
      _c(
        "v-theme-provider",
        {
          attrs: {
            dark: _vm.effectiveAppearance === "dark",
            light: _vm.effectiveAppearance === "light"
          }
        },
        [
          _c(
            "main",
            {
              class: { "brand-agreement": _vm.branding },
              style: _vm.brandStyle,
              attrs: { id: "print-area" }
            },
            [
              _c("PackageOffer", {
                key: _vm.locked + ":" + _vm.item.definition.selectionRules.mode,
                attrs: {
                  item: _vm.offer,
                  agreement: _vm.agreement,
                  "viewer-service": _vm.viewerService
                }
              }),
              _c("Signature", {
                attrs: {
                  agreement: _vm.agreement,
                  item: _vm.signature,
                  signer: _vm.viewer
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }